import React from 'react';

interface CollectibleIconProps {
  path: string;
  className?: string;
}

// Icônes "Ma collection" en line-art (trait unique, sans aplat), même traitement que le logo ibis.
const CollectibleIcon: React.FC<CollectibleIconProps> = ({ path, className }) => (
  <svg
    className={className}
    viewBox="0 0 100 100"
    fill="none"
    stroke="currentColor"
    strokeWidth={7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    dangerouslySetInnerHTML={{ __html: path }}
  />
);

// Losange — remplace le cadenas comme silhouette d'objet non débloqué
// (motif "voûtes sahéliennes" : le losange marque un objet encore à découvrir).
export const DiamondIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 100 100"
    fill="none"
    stroke="currentColor"
    strokeWidth={7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="26" y="26" width="48" height="48" rx="6" transform="rotate(45 50 50)" />
  </svg>
);

export const LockIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 100 100"
    fill="none"
    stroke="currentColor"
    strokeWidth={7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="26" y="45" width="48" height="42" rx="6" />
    <path d="M36,45 V32 a14,14 0 0 1 28,0 V45" />
    <circle cx="50" cy="64" r="5" fill="currentColor" stroke="none" />
  </svg>
);

export default CollectibleIcon;
